import Api from '@/api/api.js'

export default {
    getTarifConsultationsGeneralistes(data) {
        const promise = Api().get('/assurances/tarification/consultation/'+data.categorie_id+'/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    addConsultationPrestation(data) {
        const promise = Api().put('/assurances/tarification/consultation/store', data)
        return promise.then(response => response.data)
    },

    deleteTarifConsultation(data) {
        const promise = Api().put('/assurances/tarification/consultation/delete', data)
        return promise.then((response) => response.data)
    },

    getPrixUnitaireCatOnmt(data) {
        const promise = Api().get('/assurances/tarification/type_prestation/'+data.slug_prestation+'/'+data.groupe_id+'/'+data.assurance_id)
        return promise.then(response => response.data)
    },

    updatePrixCatOnmt(data) {
        const promise = Api().put('/assurances/tarification/type_prestation/update', data)
        return promise.then(response => response.data)
    },

    getTarifAnalyse(data) {
        const promise = Api().get('/assurances/tarification/analyses/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    addAnalysePrestation(data) {
        const promise = Api().put('/assurances/tarification/analyses/store', data)
        return promise.then(response => response.data)
    },

    getTarifChirurgie(data) {
        const promise = Api().get('/assurances/tarification/chirurgies/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    addChirurgiePrestation(data) {
        const promise = Api().put('/assurances/tarification/chirurgies/store', data)
        return promise.then(response => response.data)
    },

    // >>>>>    Examen para
    getTarifExamenPara(data) {
        const promise = Api().get('/assurances/tarification/examens/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    saveExamenPara(data) {
        const promise = Api().put('/assurances/tarification/examen/store', data)
        return promise.then(response => response.data)
    },

    // >>>>>> Medicaments
    getTarifMedicament(data) {
        const promise = Api().get('/assurances/tarification/medicaments/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    getTarifConsommable(data) {
        const promise = Api().post('/assurances/tarification/consommable', data)
        return promise.then(response => response.data)
    },

    saveMedicament(data) {
        const promise = Api().put('/assurances/tarification/medicaments/store', data)
        return promise.then(response => response.data)
    },

    // >>>>     ADMISSIONS
    getTarifTypeAdmission(type_admission) {
        const promise = Api().get('/prestations/admission/'+type_admission)
        return promise.then(response => response.data)
    },

    saveTypeAdmission(data) {
        const promise = Api().post('/prestations/admission/store', data)
        return promise.then(response => response.data)
    },

    deleteTypeAdmission(data) {
        const promise = Api().put('/prestations/admission/delete', data)
        return promise.then((response) => response.data)
    },

    // >>>> ACTES $ SOINS
    getTarifActes(type_acte) {
        const promise = Api().get('/prestations/actes/'+type_acte)
        return promise.then(response => response.data)
    },

    saveActe(data) {
        const promise = Api().post('/prestations/actes/store', data)
        return promise.then(response => response.data)
    },

    deleteActe(data) {
        const promise = Api().put('/prestations/actes/delete', data)
        return promise.then((response) => response.data)
    },

    getTarifSoins() {
        const promise = Api().get('/prestations/soins')
        return promise.then(response => response.data)
    },

    saveSoin(data) {
        const promise = Api().post('/prestations/soins/store', data)
        return promise.then(response => response.data)
    },

    deleteSoin(data) {
        const promise = Api().put('/prestations/soins/delete', data)
        return promise.then((response) => response.data)
    },

    getTarifBilanSante(data) {
        const promise = Api().get('/assurances/tarification/bilan-sante/0/'+data.assur_id)
        return promise.then(response => response.data)
    },

    saveTarifBilanSante(data) {
        const promise = Api().put('/assurances/tarification/bilan-sante/store', data)
        return promise.then(response => response.data)
    },

    getTarificationActe(data) {
        const promise = Api().post('/assurances/tarification/acte', data)
        return promise.then(response => response.data)
    },

    saveTarifActe(data) {
        const promise = Api().post('/assurances/tarification/acte/store', data)
        return promise.then(response => response.data)
    },

    getTarificationTypeAdmission(data) {
        const promise = Api().post('/assurances/tarification/type-admission', data)
        return promise.then(response => response.data)
    },

    saveTarifTypeAdmission(data) {
        const promise = Api().post('/assurances/tarification/type-admission/store', data)
        return promise.then(response => response.data)
    },

    saveTarifArticle(data) {
        const promise = Api().post('/assurances/tarification/article/store', data)
        return promise.then(response => response.data)
    },
}